<template>
    <div class="echarts-contain">
        <div :id="id" class="o-echarts"></div>
        <div class="zero" :style="{top: zeroTop + 'px', left: zeroLeft + 'px'}"></div>
        <div class="tips">
            <div class="tip-box" v-for="(item, idx) in level" :key="item.color" v-show="idx<4">
                <div class="color" :style="{background: item.color}"></div>
                <!-- <div class="text" v-if="item.max">≤{{item.max}}</div>
                <div class="text" v-else>>={{item.min}}</div> -->
                <div class="text">≥{{item.min}}{{showUnit ? unit : ''}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts';
    import JSON from '../assets/home/yunnan.json';

    export default {
        name: 'mapCharts',
        props: {
            list: Array,
            level: Array,
            unit: {
                type: String,
                default: '名'
            },
            showUnit: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                zeroTop: 0,
                zeroLeft: 0,
                option: {
                    tooltip: {
                        trigger: 'item',
                        triggerOn: 'mousemove',
                        formatter: params => {
                            return `${params.data.cityShortName || params.data.name}  ${params.data.value}${this.unit}`;
                        }
                    },
                    visualMap: {
                        show: false,
                        pieces: [],
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    itemStyle: {
                        normal: {
                            borderColor: '#fff',
                            borderWidth: 5,
                            areaStyle: { color: 'rgba(54,179,116,0.1)' }
                        }
                    },
                    series: [{
                        name: '重点关注总量',
                        type: 'map',
                        mapType: 'yunnan', // 自定义扩展图表类型
                        aspectScale: 1,
                        itemStyle: {
                            normal: { label: { show: false } },
                            emphasis: { label: { show: false } }
                        },
                        data: []
                    }]
                }
            };
        },
        mounted () {
            this.echartObj = echarts.init(document.getElementById(this.id));
            echarts.registerMap('yunnan', JSON);
            this.echartObj.setOption(this.setSeriesData(), true);
            this.echartObj.on('click', (params) => {
                console.log('paramsoffsetX:', params)
                // console.log('paramsoffsetY:', params.event.offsetY)
                this.zeroTop = params.event.offsetY
                this.zeroLeft = params.event.offsetX
            })
        },
        watch: {
            list: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            },
            zeroTop: {
                handler (newValue, oldValue) {
                    // console.log(newValue)
                }
            },
            zeroLeft: {
                handler (newValue, oldValue) {
                    // console.log(newValue)
                }
            }
        },
        methods: {
            getSeriesData () {
                // 填入省份及数据
                if (this.list.length > 0) {
                    return this.list.map(item => {
                        return {
                            name: item.name,
                            value: item.value,
                            cityShortName: item.cityShortName
                        };
                    });
                } else {
                    return JSON.features.map(item => {
                        return {
                            name: item.properties.name,
                            value: Math.ceil(Math.random() * 100)
                        };
                    });
                }
            },
            getColor () {
                // 填入颜色及范围
                if (this.level.length > 0) {
                    return this.level.map(item => {
                        return {
                            min: item.min,
                            max: item.max,
                            color: item.color
                        };
                    });
                }
            },
            setSeriesData () {
                this.setOptions('series', (() => {
                    return {
                        name: '重点关注总量',
                        type: 'map',
                        mapType: 'yunnan', // 自定义扩展图表类型
                        aspectScale: 1,
                        itemStyle: {
                            normal: { label: { show: false }, borderColor: '#fff', areaStyle: { color: 'rgba(54,179,116,0.1)' } },
                            emphasis: {
                                label: { show: false },
                                areaColor: '#188950'
                            }
                        },
                        zoom: 1.2,
                        data: this.getSeriesData()
                    }
                })());
                this.setOptions('visualMap', (() => {
                    return {
                        show: false,
                        pieces: this.getColor(),
                        textStyle: {
                            color: '#fff'
                        }
                    }
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    }
</script>

<style lang="less" scoped>
.echarts-contain{
    width: 100%;
    height: 100%;
    position: relative;
    .o-echarts {
        width: 100%;
        height: 80%;
    }
    .zero{
        width:10px;
        height:10px;
        background:red;
        border-radius: 10px;
        position: absolute;
        z-index: 99;
    }
    .tips{
        display: flex;
        margin-top: 15px;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0 45px;
        .tip-box{
            display: flex;
            align-items: center;
            .color{
                width:7px;
                height:7px;
            }
            .text{
                font-size:10px;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:10px;
                margin-left: 4px;
            }
        }
    }
}
</style>
